import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FaqItem {
  id: number;
  category_id?: number;
  category_name: string;
  question_order: number;
  question: string;
  answer: string;
  status?: string;
  createdon?: string;
  updatedon?: string | null;
  updatedby?: string | null;
  createdby?: string | null;
}

interface Pagination {
  page?: number;
  per_page?: number;
  total_items?: number;
  total_pages?: number;
  total_active?: number;
  total_inactive?: number;
}

interface FaqState {
  faqData: {
    faq: FaqItem[];
    pagination?: Pagination;
  } | null;

  singleFaqData: FaqItem | null;

  categories: any[];

  faqSuccessMsg: {
    message: string;
    id: string | number;
  };

  faqErrorMsg: {
    message: string;
    id: string | number;
  };

  loading: boolean;
  pagination: Pagination | {};
}

export const initialState: FaqState = {
  faqData: null,
  singleFaqData: null,

  categories: [],

  faqSuccessMsg: { message: "", id: "" },
  faqErrorMsg: { message: "", id: "" },

  loading: false,
  pagination: {},
};


const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {

    fetchFaqData(state, action: PayloadAction<any>) {
      state.faqData = {
       faq: action.payload?.data?.faq || [], 
        pagination: action.payload?.pagination || {},
      };
    },

    fetchSingleFaqData(state, action: PayloadAction<any>) {
      state.singleFaqData = action.payload?.data || null;
    },

    fetchFaqCategories(state, action: PayloadAction<any[]>) {
      state.categories = action.payload || [];
    },

    setPagination(state, action: PayloadAction<Pagination>) {
      state.pagination = action.payload || {};
    },

    // SUCCESS MESSAGE
    faqSuccessMsg(state, action) {
      state.faqSuccessMsg = action.payload;
    },

    // ERROR MESSAGE
    faqErrorMsg(state, action) {
      state.faqErrorMsg = action.payload;
    },

    // LOADER
    setFaqLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchFaqData,
  fetchSingleFaqData,
  fetchFaqCategories,
  setPagination,
  faqSuccessMsg,
  faqErrorMsg,
  setFaqLoader,
} = faqSlice.actions;

export default faqSlice.reducer;
